export default "__VITE_ASSET__53e6cfa2__"